import { PropertyDisplayCode } from 'src/api/generated';
import type { PropertyCodeProps } from '../../types/property-code.type';

/**
 * Format a server-resolved reference for text-only labels and accessible names.
 * @param props - Final code and the existing surface's legacy fallback.
 * @returns Display text without interpreting source identifiers or tenant settings.
 */
export function formatPropertyCode({
  displayCode,
  fallback,
  internalPrefix = '#',
}: PropertyCodeProps): string {
  if (!displayCode) return fallback;
  if (displayCode.isFallback) return `Comos · #${displayCode.value}`;
  return displayCode.source === PropertyDisplayCode.source.COMOS
    ? `${internalPrefix}${displayCode.value}`
    : displayCode.value;
}
